import {
  BedDouble,
  Boxes,
  Car,
  GraduationCap,
  HardHat,
  Laptop,
  PartyPopper,
  Plug,
  Printer,
  ShoppingBasket,
  Sparkles,
  UtensilsCrossed,
  Wrench,
} from "lucide-react";

const ICONS = {
  "Food & Beverage": UtensilsCrossed,
  Automotive: Car,
  Plumbing: Wrench,
  Contractors: HardHat,
  "Tuition Centers": GraduationCap,
  Freelancers: Laptop,
  "Beauty & Wellness": Sparkles,
  "Retail & Grocery": ShoppingBasket,
  "Electrical & Aircond": Plug,
  "Printing & Design": Printer,
  Penginapan: BedDouble,
  "Majlis & Perkahwinan": PartyPopper,
  "Lain-lain": Boxes,
};

export const categoryIcon = (category) => ICONS[category] || Boxes;
